module.exports = __webpack_public_path__ + "static/media/top.3a3d9644.png";